import React from 'react';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { offerTableHeader } from 'app/constants/table-header-constants';
import useOfferDeal from './useOfferDeal';

const OfferDeal = () => {
  const {
    isdeleteFiltering,
    filteredData,
    totalNumber,
    sectionObj,
    handleDelete,
    handleEdit,
    handleNew,
    inputChangeHandler,
    changeHandler,
    pageLoading,
    currentPage,
    dataPerPage,
    pageMeta,
    pageCount,
    paginationHandler,
    navigate,
    fetchOfferData,
  } = useOfferDeal();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          columns={offerTableHeader}
          data={filteredData}
          sectionObj={sectionObj}
          fulldata={filteredData}
          totalNumber={totalNumber}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          pageMeta={pageMeta}
          pageCount={pageCount}
          paginationHandler={paginationHandler}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleNew={handleNew}
          inputChangeHandler={inputChangeHandler}
          changeHandler={changeHandler}
          pageLoading={pageLoading}
          navigate={navigate}
          fetchData={fetchOfferData}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default OfferDeal;
